import { Action } from '@ngrx/store';
import { ISimilarPatient } from '@ispm-client/modules/similar-patients/models/similar-patient.interface';

export enum ActionTypes {
  FETCH_CURRENT_PATIENT_DATA = '[SimilarPatient] Fetch Current Patient Data',
  SET_CURRENT_PATIENT_DATA = '[SimilarPatient] Set Current Patient Data',
  SET_SIMILAR_PATIENTS_DATA = '[SimilarPatient] Set Similar Patients Data',
  CLEAR_SIMILAR_PATIENTS_DATA = '[SimilarPatient] Clear Similar Patients Data',
  SEARCH_SIMILAR_PATIENTS_DATA = '[SimilarPatient] Search Similar Patients Data',
  SIMILAR_PATIENTS_SEARCH_SUCCESS = '[SimilarPatient] Return Similar Patients Data',
  SET_ERROR = '[SimilarPatients] Set Error'
}

export enum StateTypes {
  FETCH_CURRENT_PATIENT,
  SEARCH_SIMILAR_PATIENTS
}

export class FetchCurrentPatientSimilarDataAction implements Action {
  readonly type = ActionTypes.FETCH_CURRENT_PATIENT_DATA;

  constructor(public payload: { patientId: string }) {
  }
}

export class SetCurrentPatientSimilarDataAction implements Action {
  readonly type = ActionTypes.SET_CURRENT_PATIENT_DATA;

  constructor(public payload: { currentPatientData: ISimilarPatient }) {
  }
}


export class SearchSimilarPatientsDataAction implements Action {
  readonly type = ActionTypes.SEARCH_SIMILAR_PATIENTS_DATA;

  constructor(public payload: { searchParams: any }) {
  }
}

export class SetSimilarPatientsDataAction implements Action {
  readonly type = ActionTypes.SET_SIMILAR_PATIENTS_DATA;

  constructor(public payload: { similarPatientsKeys: any, similarPatientsData: any[] }) {
  }
}

export class ClearSimilarPatientsDataAction implements Action {
  readonly type = ActionTypes.CLEAR_SIMILAR_PATIENTS_DATA;

  constructor() { }
}

export class SimilarPatientsActionSearchSuccess implements Action {
  readonly type = ActionTypes.SIMILAR_PATIENTS_SEARCH_SUCCESS;

  constructor() {}
}

export class SetErrorAction implements Action {
  readonly type = ActionTypes.SET_ERROR;

  constructor(public payload: { stateType: StateTypes, error: string }) {
  }
}

export type Actions = FetchCurrentPatientSimilarDataAction | SetCurrentPatientSimilarDataAction |
                      SearchSimilarPatientsDataAction | SetSimilarPatientsDataAction |
                      SimilarPatientsActionSearchSuccess | ClearSimilarPatientsDataAction |
                      SetErrorAction;
